import catalog from './vehicleSuggestions.json'

const normalize=(value:string)=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'')
export const vehicleBrands=Object.keys(catalog.brands).sort((a,b)=>a.localeCompare(b,'pt-BR'))
export const vehicleColors=catalog.colors
export function vehicleModels(brand:string):string[]{
 const query=normalize(brand),models=catalog.brands as Record<string,string[]>
 const key=vehicleBrands.find(value=>normalize(value)===query)??Object.entries(catalog.aliases).find(([alias])=>normalize(alias)===query)?.[1]
 return key?models[key]:[...new Set(Object.values(models).flat())].sort((a,b)=>a.localeCompare(b,'pt-BR'))
}
export function brandAliases(brand:string){return Object.entries(catalog.aliases).filter(([,value])=>value===brand).map(([alias])=>alias).join(' · ')}
